import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { API } from '@/shared/api';
import { Noticia } from '@/shared/dtos/noticia';
import NoticiaComponente from './../../../components/noticia/noticiasComponente.vue';
import { itiHttpService } from '@/iti-core-vue/services/iti-http-service';
import noticiasModule from '@/store/modules/noticias.module'

@Component({
    components: {
        NoticiaComponente,
    },
})

export default class NoticiasWeb extends Vue {

    public listaNoticias!: Noticia[];
    public noticiaSeleccionada: Noticia = new Noticia();
    public indice: number = 0;
    public paginasMostradas: boolean = false;
    @Prop() id !: number;

    public async created() {
        this.listaNoticias = [];
        this.listaNoticias = noticiasModule.noticias;//await itiHttpService.get(API.noticias).then();
        this.noticiaSeleccionada = noticiasModule.selectedNoticia; //this.listaNoticias[this.indice];
        if (this.listaNoticias.length == 0) {
            await noticiasModule.getNoticias();
            this.listaNoticias = noticiasModule.noticias;
            await noticiasModule.getNoticiaById(this.id);
            this.noticiaSeleccionada = noticiasModule.selectedNoticia;
        }
        document.documentElement.scrollTop;
        this.indice = this.noticiaSeleccionada.id - 1;
    }

    public get noticia() {
        return this.noticiaSeleccionada;
    }

    public next() {
        this.indice++;
        this.noticiaSeleccionada = this.listaNoticias[this.indice];
        document.documentElement.scrollTop = 0;
    }

    public previous() {
        this.indice--;
        this.noticiaSeleccionada = this.listaNoticias[this.indice];
        document.documentElement.scrollTop = 0;
    }

    public mostrarPaginas() {
        this.paginasMostradas = !this.paginasMostradas;
    }

    public irPagina(indice: number) {
        this.indice = indice;
        this.noticiaSeleccionada = this.listaNoticias[this.indice];
        let indiceNoticia = this.indice + 1;
        let path = '/NoticiaCompleta/' + indiceNoticia.toString();
        this.$router.push(path).catch(err => { });
    }
}